// @ts-nocheck

import { css, StyleSheet } from 'aphrodite/no-important'
import { get } from 'lodash'
import { FormFieldLayout, FormInput } from '../../generic'

export default function NumberField({
  className,
  errors,
  formFieldStyle,
  formKey,
  inputType,
  onChange,
  placeholder,
  positiveValuesOnly,
  minValue,
  readOnly,
  style,
  values,
  acceptZero = true,
  max,
  ...props
}) {
  // checks for preferredName field, which conditionally renders text
  const value = get(values, formKey)
  const error = get(errors, formKey)

  const handleChange = positiveValuesOnly
    ? (e) => {
        if (e.target.value < 0) return null

        if (max && e.target.value > max) return null

        if (!acceptZero) {
          if (e.target.value > 0) {
            return onChange({ key: formKey, value: e.target.value })
          }
        } else {
          return onChange({ key: formKey, value: e.target.value })
        }
      }
    : (e) => onChange({ key: formKey, value: e.target.value })

  const handleOnBlur = (e) => {
    if (minValue && +e.target.value < minValue) {
      onChange({ key: formKey, value: minValue })
    }
  }

  if (readOnly) return <ReadOnly value={value} />

  return (
    <FormFieldLayout hasErrors={!!error} style={formFieldStyle} {...props}>
      <div style={{ maxWidth: 120, ...style }}>
        <FormInput
          className={css(classes.input)}
          error={error}
          onChange={handleChange}
          placeholder={placeholder}
          value={value}
          type="number"
          min={minValue}
          onBlur={handleOnBlur}
          data-testid={props['data-testid']}
        />
      </div>
    </FormFieldLayout>
  )
}

const ReadOnly = ({ value }) => (
  <div className={css(classes.readOnly)}>{value}</div>
)

const classes = StyleSheet.create({
  readOnly: {
    padding: '12px 12px 12px 0px'
  },
  input: {
    textAlign: 'right'
  }
})
